import React from 'react';
import { Box, Card, Grid, Skeleton, Stack, Divider, useTheme } from '@mui/material';

const BORDER_RADIUS = '8px';
const GRID_SPACING = 3;

const IntegrationPageSkeleton = () => {
  const theme = useTheme();

  const SkeletonIntegrationCard = () => (
    <Card
      sx={{
        height: '100%',
        minHeight: 220,
        borderRadius: BORDER_RADIUS,
        border: `1px solid ${theme.palette.divider}`,
        bgcolor: theme.palette.background.paper,
        boxShadow: 'none',
        p: 2.25,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
    >
      <Box display="flex" alignItems="center" gap={2} mb={0}>
        <Skeleton variant="circular" width={40} height={40} />
        <Box flex={1}>
          <Skeleton variant="text" width="70%" height={24} />
          <Skeleton variant="text" width="40%" height={16} />
        </Box>
        <Skeleton variant="circular" width={24} height={24} />
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box sx={{ flexGrow: 1, mb: 2 }}>
        <Skeleton variant="text" height={20} />
        <Skeleton variant="text" height={20} />
        <Skeleton variant="text" width="60%" height={20} />
      </Box>

      <Box display="flex" alignItems="center" justifyContent="space-between" mt="auto">
        <Skeleton variant="text" width={120} height={20} />
        <Stack direction="row" alignItems="center" spacing={1}>
          <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: '4px' }} />
        </Stack>
      </Box>
    </Card>
  );

  return (
    <Grid container spacing={GRID_SPACING}>
      {[...Array(2)].map((_, index) => (
        <Grid key={index} item xs={12} sm={4} md={4} lg={4}>
          <SkeletonIntegrationCard />
        </Grid>
      ))}
    </Grid>
  );
};

export default IntegrationPageSkeleton;
